import React, {useState, useEffect, useRef} from "react";
import EntriesMap from "../Map/EntriesMap";
import List from '../List/List';
import {Layout, Avatar, Popover, Modal, Button} from 'antd';
import Filters from '../Filter/Presentantional';
import {useDispatch, useSelector} from "react-redux";
import {entrieslList} from "../../Core/Actions/EntriesList";
import SearchBar from '../Search/Search';
import {layoutGenerator} from 'react-break';
import {LoginC, Text, Description} from "../Styles";
import {Link} from "react-router-dom";
import {colors, routes} from "../../Constants/Constants";
import {deleteAccount} from "../../Core/Actions/Auth";
import Footer from '../Footer/Footer';
import ScrollToTop from "react-scroll-to-top";
import arrow from "../../Assets/arrow.png";


const {Sider, Content, Header} = Layout;
const screen = layoutGenerator({
    mobile: 0,
    phablet: 550,
    tablet: 768,
    desktop: 992,
});
const OnMobileTablet = screen.isAtMost('phablet');

const OnAtLeastTablet = screen.isAtLeast('tablet');


const Home = () => {
    const dispatch = useDispatch();

    const [clickedPlaces, setClickedPlaces] = useState([]);
    const [keyword, setKeyword] = useState('');
    let entries = useSelector(state => state.entries.entries);
    const image = useSelector(state => state.auth.image);

    entries = entries.filter(entry => Object.values(entry).some(val => typeof val === "string" && val.toLocaleLowerCase().includes(keyword.toLocaleLowerCase())));
    const scrollToDiv = (ref) => window.scrollTo(0, ref.current.offsetTop);
    const mapRef = useRef();
    const listRef = useRef();

    const onEntriesChanged = (entries) => {
        if (entries.length === 0) {
            return
        }

        scrollToDiv(listRef)
        setClickedPlaces(entries)
    }

    const logout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        window.location.href = '/';
    };

    const scrollToTop = () => {
        return (<ScrollToTop style={{
            height: '0px',
            width: '0px',
            marginBottom: '50px',
            marginRight: '16px',
            backgroundColor: 'transparent'
        }} smooth component={<img src={arrow}/>}/>)
    }

    const keywordHandler = (value) => {
        return setKeyword(value)
    }

    useEffect(() => {
        dispatch(entrieslList())
    }, [])
    const content = (
        <div>
            <p onClick={() => {
                dispatch(deleteAccount())
            }} style={{color: '#121212', cursor: 'context-menu', marginBottom: '0px'}}>Delete Account</p>
            <p onClick={() => {
                logout()
            }} style={{color: '#121212', cursor: 'context-menu', marginBottom: '0px'}}>Log out</p>
        </div>
    );

    return (
        <div>

            <OnAtLeastTablet>
                <Layout style={{backgroundColor: "white", marginTop: '50px'}}>
                    {scrollToTop()}
                    <Content style={{padding: '50px', backgroundColor: "white"}}>
                        <Header style={{background: colors.darkOrange}}>
                            <Popover style={{padding: '0px'}} placement="bottom" content={content} trigger="click">
                                <Avatar size="large" src={image}/>
                            </Popover>
                        </Header>
                        <Layout style={{padding: '24px 0', backgroundColor: '#f5f5f5'}}>
                            <Sider style={{
                                padding: '10px',
                                marginLeft: '20px',
                                backgroundColor: 'white',
                                textAlign: '-webkit-center',
                            }}
                                   width={300}>
                                <Filters onPlacesClicked={onEntriesChanged} showTooltip={true}/>
                            </Sider>
                            <Content
                                style={{padding: '0 24px', minHeight: 280, textAlign: 'center', overflow: 'hidden'}}>
                                <SearchBar keyword={keyword} keywordHandler={keywordHandler}/>
                                <EntriesMap refference={mapRef}
                                            onPlacesClicked={onEntriesChanged} entries={entries}/>
                                <List refference={listRef} selectedPlaces={clickedPlaces} entries={entries}
                                      size={window.innerWidth / 4}
                                      height={'300px'}/>
                            </Content>
                        </Layout>
                        <Footer>
                            <Description style={{color: 'white'}}>
                                © 2020 Shtëpia+
                            </Description>
                            <Description style={{color: 'white'}}>
                                <Link to={`${routes.App.Privacy}`}
                                      style={{color: 'white', textDecoration: 'blink'}}> Privacy
                                    Policy </Link>
                            </Description>
                        </Footer>
                    </Content>
                </Layout>
            </OnAtLeastTablet>
            <OnMobileTablet style={{textAlign: '-webkit-center'}}>
                {scrollToTop()}
                <LoginC style={{justifyContent: 'space-around', padding: '10px'}}>
                    <Link to={`${routes.App.Home}`} style={{color: 'white', textDecoration: 'blink'}}> <Text>
                        Shtëpia+
                    </Text> </Link>
                    <Popover style={{padding: '0px'}} placement="bottom" content={content} trigger="click">
                        <Avatar size="large" src={image}/>
                    </Popover>
                </LoginC>
                <SearchBar top={'120px'} width={'90%'} keywordHandler={keywordHandler}/>
                <EntriesMap refference={mapRef} onPlacesClicked={onEntriesChanged}
                            entries={entries} size={'90%'}/>
                <Filters onPlacesClicked={onEntriesChanged} showTooltip={true}/>
                <List refference={listRef} selectedPlaces={clickedPlaces} entries={entries} size={'250px'} height={'100%'}/>
                <Footer/>

            </OnMobileTablet>
        </div>

    );
};

export default Home;
